import { fireBrandConfetti } from "@/components/celebrations/confetti-burst";

const STORAGE_PREFIX = "ease:published:";

export function getFirstPublishConfettiKey(pageId: string): string {
  return `${STORAGE_PREFIX}${pageId}`;
}

export function maybeFireFirstPublishConfetti(
  pageId: string | null | undefined,
  options?: {
    storage?: Pick<Storage, "getItem" | "setItem">;
    fire?: typeof fireBrandConfetti;
  },
): boolean {
  if (!pageId) {
    return false;
  }

  const storage = options?.storage ?? globalThis.localStorage;
  const fire = options?.fire ?? fireBrandConfetti;
  const key = getFirstPublishConfettiKey(pageId);

  try {
    if (storage.getItem(key)) {
      return false;
    }

    storage.setItem(key, "1");
    fire("normal");
    return true;
  } catch {
    return false;
  }
}
